var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddRound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1072.000000, -321.000000) translate(1072.000000, 321.000000)",
    stroke: "#1F7057",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 1.07,
    cx: 16.5,
    cy: 16.5,
    r: 15.965
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "M7 16.9857143L27 16.9857143"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "M17 8.67755102L17 26.0163265"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRound);
export default __webpack_public_path__ + "static/media/add-round.a504947b7066b8ccfdd82323e33e107c.svg";
export { ForwardRef as ReactComponent };